import BrandSliderTwo from "../components/BrandSliderTwo";
import CoreFeatures from "../components/CoreFeatures";
import CounterUpThree from "../components/CounterUpThree";
import HomeThreeAbout from "../components/HomeThreeAbout";
import HomeThreeBanner from "../components/HomeThreeBanner";
import HomeThreeBlog from "../components/HomeThreeBlog";
import HomeThreeContact from "../components/HomeThreeContact";
import PortfolioTwo from "../components/PortfolioTwo";
import ServicesThree from "../components/ServicesThree";
import TestimonialThree from "../components/TestimonialThree";
import WorkProcessTwo from "../components/WorkProcessTwo";
import FooterThree from "../footer/FooterThree";
import HeaderThree from "../header/HeaderThree";

export default function HomeThree(){
	return(
		<>	
			<HeaderThree/>
			<HomeThreeBanner/>
			<ServicesThree/>
			<HomeThreeAbout/>
			<CoreFeatures/>
			<PortfolioTwo/>
			<CounterUpThree/>
			<WorkProcessTwo/>
			<TestimonialThree/>
			<BrandSliderTwo/>
			<HomeThreeBlog/>
			<HomeThreeContact/>
			<FooterThree/>
		</>
	)
}
